<template>
	<article class="layout-3-col-wrapper">
		<div class="left"></div>
		<div class="middle">
			<spinner v-if="statsStatus.loading"></spinner>
			<div class="row" v-if="!statsStatus.loading">
				<div class="content">
					<p><span class="lead-in">Credits</span> allow you to customize your subscription to get
					the most out of what matters to you.</p>

					<div class="credit-details">
						<h3>How Credits Work</h3>
						<p>Each integration takes a certain number of credits to activate. However,
						credits are not gone when you use them. You can free up your credits by
						deactivating or changing the options of an active integration. </p>

						<p>Every base subscription comes with 10 credits. In the future,
						you will be able to add credits to your account by purchasing monthly add-ons.
						</p>
					</div>
				</div>
				<div class="donut">
					<div class="svg-donut" :style="cssVars" >
						<svg width="100%" height="100%" viewBox="0 0 40 40" >
							<circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>
							<circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"></circle>
							<circle class="donut-segment" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5" :stroke-dasharray="`${(creditsUsed / creditsLimit) * 100} ${(creditsRemaining / creditsLimit) * 100}`" stroke-dashoffset="25"></circle>
							<g class="donut-text">
								<text y="43%" transform="translate(0, 2)">
									<tspan x="42%"  class="donut-total-label"> {{ creditsLimit }} </tspan>
									<tspan x="42%" dy="1em"  class="donut-total-label"> Credits</tspan>
								</text>
								<line  x1="17.5" y1="13" x2="17.5" y2="25" stroke-width=".25" stroke="#f1f3f6"></line>
								<text y="40%" transform="translate(0, 2)">
									<tspan x="46%" text-anchor="start" class="donut-used-label"> {{ creditsUsed }} <tspan>Used</tspan></tspan>
								</text>
								<text y="50%" transform="translate(0, 2)">
									<tspan x="46%" text-anchor="start" class="donut-remaining-label">{{ creditsRemaining }} <tspan>Available</tspan></tspan>
								</text>
							</g>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div class="right"></div>
	</article>
</template>

<script>
	import Spinner from '../components/Spinner';
	import date from '../filters/date';
	import { mapGetters } from 'vuex';

	export default {
		name: 'Credits',
		data(){
			return {};
		},
		components: {
			Spinner
		},
		computed: {
			...mapGetters([
				'user',
				'credits',
				'statsStatus'
			]),
			creditsLimit() {
				return this.credits && this.credits.limit;
			},
			creditsUsed() {
				return this.credits && this.credits.used;
			},
			creditsRemaining() {
				return this.credits && this.credits.remaining;
			},
			cssVars() {
				return {
					'--creditsRemaining': this.creditsRemaining / this.creditsLimit * 100,
					'--creditsUsed' : this.creditsUsed / this.creditsLimit * 100,
				};
			}
		},
		methods: {
		},
		created() {
		}
	};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.layout-3-col-wrapper{
		flex-wrap: wrap;
	}
	.right, .left{
		flex-basis: 0;
	}

	line {
		stroke: #CBCED3;
	}
	.lead-in{
		font-size: 1.2em;
	}
	.donut {
		flex: 1 0 300px;
	}
	.content{
		flex: 0 1 auto;
	}
	.content > p:first-child {
		margin-top: 0;
	}
	.svg-donut {
		width: 100%;
		font-size: 16px;
		margin: 0 auto;
		animation: donutfade 1s;
	}

	.credit-details {
		margin-top: 10%;
	}

	@keyframes donutfade {
	/* this applies to the whole svg item wrapper */
		0% {
			opacity: .2;
		}
		100% {
			opacity: 1;
		}
	}

	tspan tspan{
		font-size: .9em;
	}
	.donut-ring {
		stroke: #CBCED3	;
		stroke: #e3e6ea	;
	}

	.donut-segment {
		stroke:#2C8EFF;
		animation: donut1 2s;
	}

	.donut-used-label {
		animation: donutfadelong 1s;
	}

	@keyframes donutfadelong {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes donut1 {
		0% {
			stroke-dasharray: 0, 100;
		}
		100% {
			stroke-dasharray: var(--creditsUsed), var(--creditsRemaining);
		}
	}

	.donut-text {
		fill: #222;
	}

	.donut-total-label{
		font-size: 0.35em;
		line-height: 1;
		text-anchor: end;
	}

	.donut-total-label:last-of-type{
		font-size:.18em;
	}
	.donut-used-label {
		font-size: 0.20em;
		line-height: 1;
		transform: translateY(0.5em);
	}

	.donut-remaining-label {
		font-size: .20em;
		line-height: 1;
		transform: translateY(0.5em);
		text-align: left;
		color:#222;
		fill: #222;
		animation: donutfadelong 1s;
	}

	/* // Extra small devices (portrait phones, less than 576px) */
	@media (max-width: 575.98px) {
		.middle{
			width:100%;
			flex-basis:100%;
			padding:20px 0 40px;
		}
		.row{
			flex-wrap: wrap;
		}
		.svg-donut{
			width: 80%;
		}
		.donut{
			order: -1;
		}
	}

	/* // Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) and (max-width: 767.98px) {
		.middle{
			width:100%;
			flex-basis:100%;
			padding:20px 0 40px;
		}
		.svg-donut{
			width:80%;
		}
		/* .svg-donut{
			width: 50%;
		}
		.donut{
			order: -1;
		}
		.row{
			flex-wrap: wrap;
		} */
	}

	/* // Medium devices (tablets, 768px and up) */
	@media (min-width: 768px) and (max-width: 991.98px) { .item-tile{display:none;}}

	/* // Large devices (desktops, 992px and up) */
	@media (min-width: 992px) and (max-width: 1199.98px) {.item-tile{display:none;}  }

	/* // Extra large devices (large desktops, 1200px and up) */
	@media (min-width: 1200px) {

	}
</style>



// WEBPACK FOOTER //
// src/views/Credits.vue